import React from "react";
import ReactMarkdown from "react-markdown";
import DOMPurify from "dompurify";
import gfm from "remark-gfm";

const MarkdownRenderer = ({ markdown = "" }) => {
  // Ensure markdown is a string
  const cleanText =
    typeof markdown === "string" ? markdown.replace(/```/g, "") : "";
  const sanitizedMarkdown = DOMPurify.sanitize(cleanText);

  return (
    <ReactMarkdown
      remarkPlugins={[gfm]}
      components={{
        p: ({ children, ...props }) => (
          <p style={{ margin: "0.5em 0" }} {...props}>
            {children}
          </p>
        ),
        ul: ({ children, ...props }) => (
          <ul style={{ margin: "0.5em 0" }} {...props}>
            {children}
          </ul>
        ),
        ol: ({ children, ...props }) => (
          <ol style={{ margin: "0.5em 0" }} {...props}>
            {children}
          </ol>
        ),
        li: ({ children, ...props }) => (
          <li style={{ margin: "0.25em 0" }} {...props}>
            {children}
          </li>
        ),
        a: ({ children, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer">
            {children || "Link"}
          </a>
        ),
        img: (props) => (
          <img alt="markdown-img" style={{ maxWidth: "100%" }} {...props} />
        ),
        code: ({ children, ...props }) => (
          <code style={{ whiteSpace: "pre-wrap" }} {...props}>
            {children}
          </code>
        ),
      }}
    >
      {sanitizedMarkdown}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
